import axios from '@fs/zion-axios'

/**
 * Gets the source language from an artifact
 * @param {Object} artifact - The artifact containing language information
 * @returns {string} The source language code or 'en' as fallback
 */
export function getSourceLanguage(artifact) {
  return artifact?.languages?.[0] || 'en'
}

/**
 * Translates text using the translated API
 * @param {string} text - The text to translate
 * @param {string} sourceLanguage - The source language of the text
 * @param {string} targetLanguage - The language to translate to
 * @returns {Promise<string>} Promise resolving to translated text
 */
export async function translateWithTranslatedApi(text, sourceLanguage, targetLanguage) {
  const response = await axios.get('/records/improve/translatedApi', {
    params: {
      text,
      sourceLanguage,
      targetLanguage,
    },
    headers: { 'Content-Type': 'application/json' },
  })

  if (response.data.error) {
    throw new Error(`Translation failed: ${response.data.error}`)
  }

  return response.data.translation
}
